export const environment = {
  id: '4u',
  production: false,
  baseUrl: 'https://4u.superlikerslabs.com',
  photosPath: 'https://superlikers-staging.s3.amazonaws.com/uploads/upload-photo'
}
